// extracted by mini-css-extract-plugin
export default {"card":"BannerCard_card__RauVu","container":"BannerCard_container__M-Cc9","title":"BannerCard_title__VDtxY","content":"BannerCard_content__wTk1C"};